// extracted by mini-css-extract-plugin
export default {"area":"Bubbles_area__ClmNj","circles":"Bubbles_circles__Fpd7D","animate":"Bubbles_animate__DmJ41"};